import { permissionManager } from "../PermissionManager/PermissionManager";

export const PE_PLUGIN_EDIT_ALL = 'fv--plugin-PageEditor-edit-all'
export const PE_PLUGIN_EDIT_TEXT = 'fv--plugin-PageEditor-edit-text'
export const PE_PLUGIN_EDIT_IMAGE = 'fv--plugin-PageEditor-edit-image'
export const PE_PLUGIN_EDIT_PATH = 'fv--plugin-PageEditor-edit-path'
export const PE_PLUGIN_EDIT_SHADING = 'fv--plugin-PageEditor-edit-shading'

export const PE_PLUGIN_ADD_TEXT = 'fv--plugin-PageEditor-add-text'
export const PE_PLUGIN_ADD_IMAGE = 'fv--plugin-PageEditor-add-image'

export const PE_PLUGIN_ADD_PATH_LINE = 'fv--plugin-PageEditor-add-path-line'
export const PE_PLUGIN_ADD_PATH_RECTANGLE = 'fv--plugin-PageEditor-add-path-rectangle'
export const PE_PLUGIN_ADD_PATH_ROUNDRECT = 'fv--plugin-PageEditor-add-path-roundrect'
export const PE_PLUGIN_ADD_PATH_ELLIPSE = 'fv--plugin-PageEditor-add-path-ellipse'
export const PE_PLUGIN_ADD_PATH_POLYLINE = 'fv--plugin-PageEditor-add-path-polyline'
export const PE_PLUGIN_ADD_PATH_POLYGON = 'fv--plugin-PageEditor-add-path-polygon'
export const PE_PLUGIN_ADD_PATH_POLYBEZIER = 'fv--plugin-PageEditor-add-path-polybezier'
export const PE_PLUGIN_ADD_PATH_CURVE = 'fv--plugin-PageEditor-add-path-curve'
export const PE_PLUGIN_ADD_PATH_FREEDOM = 'fv--plugin-PageEditor-add-path-freedom'

export const PE_PLUGIN_ADD_SHADING_RECTANGLE = 'fv--plugin-PageEditor-add-shading-rectangle'
export const PE_PLUGIN_ADD_SHADING_ROUNDRECT = 'fv--plugin-PageEditor-add-shading-roundrect'
export const PE_PLUGIN_ADD_SHADING_ELLIPSE = 'fv--plugin-PageEditor-add-shading-ellipse'
export const PE_PLUGIN_ADD_SHADING_POLYLINE = 'fv--plugin-PageEditor-add-shading-polyline'
export const PE_PLUGIN_ADD_SHADING_POLYGON = 'fv--plugin-PageEditor-add-shading-polygon'
export const PE_PLUGIN_ADD_SHADING_POLYBEZIER = 'fv--plugin-PageEditor-add-shading-polybezier'
export const PE_PLUGIN_ADD_SHADING_CURVE = 'fv--plugin-PageEditor-add-shading-curve'
export const PE_PLUGIN_ADD_SHADING_FREEDOM = 'fv--plugin-PageEditor-add-shading-freedom'

export const PE_PLUGIN_HOME_EDIT_ALL = 'All';
export const PE_PLUGIN_HOME_EDIT_TEXT = 'Text';
export const PE_PLUGIN_HOME_EDIT_IMAGE = 'Image';
export const PE_PLUGIN_HOME_EDIT_PATH = 'Path';
export const PE_PLUGIN_HOME_EDIT_SHADING = 'Shading';

export const PE_PLUGIN_ALL_BTNS = [
  PE_PLUGIN_EDIT_ALL,
  PE_PLUGIN_EDIT_TEXT,
  PE_PLUGIN_EDIT_IMAGE,
  PE_PLUGIN_EDIT_PATH,
  PE_PLUGIN_EDIT_SHADING,
  PE_PLUGIN_HOME_EDIT_ALL,
  PE_PLUGIN_HOME_EDIT_TEXT,
  PE_PLUGIN_HOME_EDIT_IMAGE,
  PE_PLUGIN_HOME_EDIT_PATH,
  PE_PLUGIN_HOME_EDIT_SHADING,

  PE_PLUGIN_ADD_TEXT,
  PE_PLUGIN_ADD_IMAGE,

  PE_PLUGIN_ADD_PATH_LINE,
  PE_PLUGIN_ADD_PATH_RECTANGLE,
  PE_PLUGIN_ADD_PATH_ROUNDRECT,
  PE_PLUGIN_ADD_PATH_ELLIPSE,
  PE_PLUGIN_ADD_PATH_POLYLINE,
  PE_PLUGIN_ADD_PATH_POLYGON,
  PE_PLUGIN_ADD_PATH_POLYBEZIER,
  PE_PLUGIN_ADD_PATH_CURVE,
  PE_PLUGIN_ADD_PATH_FREEDOM,

  PE_PLUGIN_ADD_SHADING_RECTANGLE,
  PE_PLUGIN_ADD_SHADING_ROUNDRECT,
  PE_PLUGIN_ADD_SHADING_ELLIPSE,
  PE_PLUGIN_ADD_SHADING_POLYLINE,
  PE_PLUGIN_ADD_SHADING_POLYGON,
  PE_PLUGIN_ADD_SHADING_POLYBEZIER,
  PE_PLUGIN_ADD_SHADING_CURVE,
  PE_PLUGIN_ADD_SHADING_FREEDOM,
]

export const PE_PLUGIN_PREMIUM_BTNS = [
  PE_PLUGIN_EDIT_ALL,
  PE_PLUGIN_EDIT_TEXT,
  PE_PLUGIN_EDIT_IMAGE,
  PE_PLUGIN_EDIT_PATH,
  PE_PLUGIN_EDIT_SHADING,
  PE_PLUGIN_HOME_EDIT_ALL,
  PE_PLUGIN_HOME_EDIT_TEXT,
  PE_PLUGIN_HOME_EDIT_IMAGE,
  PE_PLUGIN_HOME_EDIT_PATH,
  PE_PLUGIN_HOME_EDIT_SHADING,
  PE_PLUGIN_ADD_TEXT,
  PE_PLUGIN_ADD_IMAGE,
  PE_PLUGIN_ADD_PATH_LINE,
  PE_PLUGIN_ADD_PATH_RECTANGLE,
  PE_PLUGIN_ADD_PATH_ROUNDRECT,
  PE_PLUGIN_ADD_PATH_ELLIPSE,
  PE_PLUGIN_ADD_PATH_POLYLINE,
  PE_PLUGIN_ADD_PATH_POLYGON,
  PE_PLUGIN_ADD_PATH_POLYBEZIER,
  PE_PLUGIN_ADD_PATH_CURVE,
  PE_PLUGIN_ADD_PATH_FREEDOM,
  PE_PLUGIN_ADD_SHADING_RECTANGLE,
  PE_PLUGIN_ADD_SHADING_ROUNDRECT,
  PE_PLUGIN_ADD_SHADING_ELLIPSE,
  PE_PLUGIN_ADD_SHADING_POLYLINE,
  PE_PLUGIN_ADD_SHADING_POLYGON,
  PE_PLUGIN_ADD_SHADING_POLYBEZIER,
  PE_PLUGIN_ADD_SHADING_CURVE,
  PE_PLUGIN_ADD_SHADING_FREEDOM,
]


permissionManager.registerPremiumFeatures(PE_PLUGIN_PREMIUM_BTNS);
permissionManager.registerCNJPPremiumFeatures(PE_PLUGIN_PREMIUM_BTNS);